<template>
  <v-btn rounded v-if="isRecalculating" :min-width="60">
    <v-icon small class="mr-1">fas fa-spinner fa-spin</v-icon>
  </v-btn>
  <v-btn rounded v-else>{{score}}</v-btn>
</template>

<script>
export default {
  name: "ModelPerformanceChip",
  props: {
    model: {required: true},
    threshold: {required: true}
  },
  data() {
    return {
      isRecalculating: false,
      pollInterval: null
    }
  },
  computed: {
    score () {
      let performance = this.model.performance;
      if(!performance) {
        return '-'
      }
      else {
        performance = JSON.parse(performance);
        return Math.round(performance['correct_' + this.threshold] * 100) + '%';
      }
    }
  },
  async mounted() {
    await this.checkRecalculationStatus();
    // Poll every 3 seconds to check if recalculation is still in progress
    this.pollInterval = setInterval(async () => {
      await this.checkRecalculationStatus();
    }, 3000);
  },
  beforeDestroy() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
    }
  },
  methods: {
    async checkRecalculationStatus() {
      try {
        // Check for active confusion matrix calculation job
        const confMatrixJobs = await this.$api.job.get_active_jobs('calculate_conf_matrix_items', undefined, undefined, this.model.id);
        // Check for active performance calculation job
        const performanceJobs = await this.$api.job.get_active_jobs('calculate_performance_job', undefined, undefined, this.model.id);
        
        // Check if any of the jobs are not processed yet
        const hasActiveConfMatrixJob = confMatrixJobs && confMatrixJobs.length > 0 && confMatrixJobs.some(job => job.processed === 0);
        const hasActivePerformanceJob = performanceJobs && performanceJobs.length > 0 && performanceJobs.some(job => job.processed === 0);
        
        this.isRecalculating = hasActiveConfMatrixJob || hasActivePerformanceJob;
      } catch (error) {
        console.error('Error checking recalculation status:', error);
        // On error, don't show loader
        this.isRecalculating = false;
      }
    }
  }
}
</script>

<style scoped>

</style>